import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared/shared.module';
import {AuthService} from './auth.service';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [ LoginComponent ],
  providers: [
    AuthService
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts